import { type GaugeModule, gaugeValue, setGauge } from '../../gauges';
import { isSprinting } from '../skills/sprint';

const RUNNING_SHARE = 0.8;

export const elanGauge: GaugeModule = ({ tempo }, player, gauge, definition) => {
  const { attack } = definition;
  if (attack.kind !== 'ball') {
    throw new Error(`class "${definition.id}" has an Élan but kicks no ball`);
  }
  if (isSprinting(player) && !player.downed) {
    setGauge(player, gauge, gauge.max);
    return;
  }
  const dx = player.x - player.prevX;
  const dy = player.y - player.prevY;
  const running =
    !player.downed &&
    (player.slowFactor ?? 1) >= 1 &&
    dx * dx + dy * dy >= RUNNING_SHARE * RUNNING_SHARE * player.speed * player.speed;
  const step = running
    ? gauge.max / (attack.elan.fillBars * tempo.ticksPerBar)
    : -gauge.max / (attack.elan.drainBeats * tempo.ticksPerBeat);
  setGauge(player, gauge, snapped(gaugeValue(player) + step, gauge.max, Math.abs(step)));
};

// Within half a step of an end, the end itself: a sum of steps lands on it exactly.
function snapped(value: number, max: number, step: number): number {
  if (Math.abs(value - max) < step / 2) {
    return max;
  }
  return Math.abs(value) < step / 2 ? 0 : value;
}
